module.exports = __webpack_public_path__ + "static/japan04-65fa83aa1b9b9f96dacd889b50fb58bd.jpg";